class LangDirective {
  static directive($rootScope, $translate, ProfileService) {
    'ngInject';
    return {
      restrict: 'A',
      template: `
        <md-select ng-model="langModel" ng-change="selectChanged()" class="md-no-underline">
          <md-option ng-repeat="l in langs" ng-value="{{l}}" ng-selected="{{l.name == langModel.name}}"  class="lang-selector" >
              <img ng-src="{{l.flag}}" class="lang-selector-image">
          </md-option>
        </md-select>
      `,
      link: function ($scope) {
        // $rootScope.$on('server-userLoggedIn', (event) => {
        //   ProfileService.getCurrentClientData().then(info => {
        //     console.log('info.language.toLowerCase()', info.language.toLowerCase());
        //       angular.forEach($scope.langs, (lang) => {
        //         if(lang.name == info.language.toLowerCase()) {
        //           console.log('setting lang', lang);
        //           $scope.langModel = {
        //             name : lang.name,
        //             flag: lang.flag
        //           };
        //           $translate.use($scope.langModel.name);
        //         }
        //       });
        //   });
        // });
      },
      controller: function ($scope) {
        'ngInject';

        $scope.vm = {};

        $scope.langs = [
          {name: "en", flag: require("../../assets/flags/usa.png")},
          {name: "pl", flag: require("../../assets/flags/poland.png")}
        ];

        if(localStorage['lang']) {
          angular.forEach($scope.langs, (lang) => {
            if(lang.name === localStorage['lang']) {
              console.log('setting lang ', lang);
              $scope.langModel = lang;
            }
          });
        }else {
          $scope.langModel = $scope.langs[1];
        }

        $scope.selectChanged = function(){
          localStorage['lang'] = $scope.langModel.name;
          $translate.use($scope.langModel.name);
        };

      }
    };
  }
}

export default LangDirective.directive;



// WEBPACK FOOTER //
// ./src/commons/lang.directive.js